module.exports = __webpack_public_path__ + "img/login-v2.e63fd8b0.svg";